module.exports = __webpack_public_path__ + "static/media/logo_lignano.be4939cd.svg";